import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import {Button, Form, Container, Row, Col,Dropdown} from 'react-bootstrap';
import ScrollAnimation from 'react-animate-on-scroll';
import Select from 'react-dropdown-select';
import { navigate } from "@reach/router"
import $ from "jquery";
import _ from "lodash"
// import options from './test';
import "./FilterBlock.scss"
import SearchInputBox from '../../predictive-search/search-areas';
import { isMobileOnly } from "react-device-detect";

// markup
const FilterBlock = (props) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [areaVal, setAreaVal] = useState('');
  const [minpriceVal, setMinPriceVal] = useState('');
  const [maxpriceVal, setMaxPriceVal] = useState('');
  const [propertyval, setPropertyVal] = useState('');
  const [salesVal, setSalesVal] = useState('');
  const [bedVal, setBedVal] = useState('');
  const [minPriceList, setMinPriceList] = useState([]);
  const [maxPriceList, setMaxPriceList] = useState([]);

  const [show, setShow] = useState(false);
  const showMenu = () => {
    setShow(!show);
  };

  const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
  const priceminRange = [
    { value: "0", label: "No Min" },
    { value: "100000", label: "£100,000" },
    { value: "200000", label: "£200,000" },
    { value: "300000", label: "£300,000" },
    { value: "400000", label: "£400,000" },
    { value: "500000", label: "£500,000" },
    { value: "600000", label: "£600,000" },
    { value: "700000", label: "£700,000" },
    { value: "800000", label: "£800,000" },
    { value: "900000", label: "£900,000" },
    { value: "1000000", label: "£1,000,000" },
    { value: "1100000", label: "£1,100,000" },
    { value: "1200000", label: "£1,200,000" },
    { value: "1300000", label: "£1,300,000" },
    { value: "1500000", label: "£1,500,000" },
    { value: "2000000", label: "£2,000,000" },
    { value: "2500000", label: "£2,500,000" },
    { value: "3000000", label: "£3,000,000" },

  ];
  const priceminRangeLettings = [
    { value: "0", label: "No Min" },
    { value: "200", label: "£200pcm" },
    { value: "300", label: "£300pcm" },
    { value: "400", label: "£400pcm" },
    { value: "500", label: "£500pcm" },
    { value: "600", label: "£600pcm" },
    { value: "700", label: "£700pcm" },
    { value: "800", label: "£800pcm" },
    { value: "900", label: "£900pcm" },
    { value: "1000", label: "£1,000pcm" },
    { value: "1100", label: "£1,100pcm" },
    { value: "1200", label: "£1,200pcm" },
    { value: "1300", label: "£1,300pcm" },
  ];

  const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);
  const pricemaxRange = [
    { value: "0", label: "No Max" },
    { value: "3000000", label: "£3,000,000  +" },
    { value: "2500000", label: "£2,500,000" },
    { value: "2000000", label: "£2,000,000" },
    { value: "1500000", label: "£1,500,000"},
    { value: "1300000", label: "£1,300,000" },
    { value: "1200000", label: "£1,200,000" },
    { value: "1100000", label: "£1,100,000" },
    { value: "1000000", label: "£1,000,000" },
    { value: "900000", label: "£900,000" },
    { value: "800000", label: "£800,000" },
    { value: "700000", label: "£700,000" },
    { value: "600000", label: "£600,000" },
    { value: "500000", label: "£500,000" },
    { value: "400000", label: "£400,000" },
    { value: "300000", label: "£300,000" },
    { value: "200000", label: "£200,000" },
    { value: "100000", label: "£100,000" },
  ];
  const pricemaxRangeLettings = [
    { value: "0", label: "No Max" },
    { value: "1300", label: "£1,300pcm +" },
    { value: "1200", label: "£1,200pcm" },
    { value: "1100", label: "£1,100pcm" },
    { value: "1000", label: "£1,000pcm" },
    { value: "900", label: "£900pcm" },
    { value: "800", label: "£800pcm" },
    { value: "700", label: "£700pcm" },
    { value: "600", label: "£600pcm" },
    { value: "500", label: "£500pcm" },
    { value: "400", label: "£400pcm" },
    { value: "300", label: "£300pcm" },
    { value: "200", label: "£200pcm" },
  ];
  const Bedrooms = [
    { value: "", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' }
  ];
  const AllTypes = [
    { value: "", label:"All" },
    { value: "house", label: "House" },
    { value: "apartment", label: "Apartment" },
    { value: "bungalow", label: "Bungalow" },
    { value: "maisonette", label: "Maisonette" },
    { value: "development-plot", label: "Development Plot" },
    { value: "land", label: "Land" },
  ];

  function stringContainsNumber(_string) {
    return /\d/.test(_string);
  }

  // Min price
  const onChangeMinPrice = (e) => {
    setSelectedMinPriceValue(e[0].value);
  }
  // Min price

  // Max Price
  const onChangeMaxPrice = (e) => {
    setSelectedMaxPriceValue(e[0].value);
  }
  // Max Price

  // Sales price list
  var minPrice = [];
  var maxPrice = pricemaxRange.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

  priceminRange.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPrice.push(items));

  if (minPrice.length > 0) {
  } else {
    minPrice.push(priceminRange[0])
  }

  if (maxPrice.length > 0) {
  } else {
    maxPrice.push(pricemaxRange[0])
  }
  // Sales price list

  // Lettings price list
  var minPriceLettings = [];
  var maxPriceLettings = pricemaxRangeLettings.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

  priceminRangeLettings.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPriceLettings.push(items));

  if (minPriceLettings.length > 0) {
  } else {
    minPriceLettings.push(priceminRangeLettings[0])
  }

  if (maxPriceLettings.length > 0) {
  } else {
    maxPriceLettings.push(pricemaxRangeLettings[0])
  }
  // Lettings price list

  useEffect(() => {
    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0">');
    if (_.isEmpty(minPriceList)) {
      if (props.type === "lettings") {
        setMinPriceList(priceminRangeLettings);
        setMaxPriceList(pricemaxRangeLettings);
      } else {
        setMinPriceList(priceminRange)
        setMaxPriceList(pricemaxRange)
      }
    }

    const url = typeof window !== 'undefined' ? window.location.href : ''
    let pathUri = url.split("/")
    for (let vi = 1; vi <= pathUri.length; vi++) {
      // check for area
      if (typeof pathUri[vi] === "undefined") {
        continue
      }
      var selectedParams = props.searchParams
      // Property type
      // if (pathUri[vi].indexOf("type-") >= 0) {
      if(selectedParams && selectedParams.type) {
        setPropertyVal(selectedParams.type)
      }
      // Property type

      // Area
      // if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-essex-and-kent") == -1)) {
      if (selectedParams && selectedParams.areas!="essex-and-kent" && selectedParams.areas) {
        setAreaVal(_.upperFirst(selectedParams.areas).replace(/-/g, " "))

        //props.areaValChange(selectedParams.areas)
      }

      //console.log("selectedParams", selectedParams.areas)
      // Area

      // Price
      if (
        pathUri[vi].indexOf("between-") >= 0 ||
        pathUri[vi].indexOf("over-") >= 0 ||
        pathUri[vi].indexOf("under-") >= 0
      ) {
        let priceFilt1 = pathUri[vi].split("over-")
        if (priceFilt1[1]) {
          setMinPriceVal(priceFilt1[1])
        }
        let priceFilt2 = pathUri[vi].split("under-")
        if (priceFilt2[1]) {
          setMaxPriceVal(priceFilt2[1])
        }
        let priceFilt3 = pathUri[vi].split("between-")
        if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-and-")
          setMinPriceVal(priceFilt4[0])
          setMaxPriceVal(priceFilt4[1])
        }
      }
      // Price

      // Bedrooms
      if (pathUri[vi].indexOf("-and-more-") >= 0) {
        setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
      }
      // Bedrooms 
    }
  }, []);

  // Submit search
  const submitSearch = (e) => {
    //var areaValue = $(".search-box .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    // var areaValue = "essex-and-kent"
    // var areaValue = $(".searchboxresults .react-autosuggest__input").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    // if(_.isEmpty(areaValue)){
    //   areaValue = $(".mobsearchboxresults .react-autosuggest__input").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    // }
    var areaValue = "essex-and-kent";
    if($(".search-box .searchVal").val().length > 0) {
      areaValue = $(".search-box .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    } 
    setAreaVal(areaValue);

    console.log("areaValue", areaValue, areaVal)

    props.areaValChange(areaValue);

    var searchTypeValue = salesVal;
    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".building-dropdown input[type='hidden']").val();
    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-" + minpriceVal + "-and-" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "under-" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "over-" + minpriceVal
        }
    }

    var searchFilterResults = (
      props.department === "new_developments"? 

      (areaValue ? (props.type === "sales" ? (props.tag === "map" ? "/new-homes-map/for-sale/" + areaValue + "/" : "/new-homes-for-sale/" + areaValue + "/") : (props.tag === "map" ? "/new-homes-map/to-rent/" + areaValue + "/" : "/new-homes-to-rent/" + areaValue + "/")) : (props.type === "sales" ? (props.tag === "map" ? "/new-homes-map/for-sale/essex-and-kent/" : "/new-homes-for-sale/essex-and-kent/") : (props.tag === "map" ? "/new-homes-map/to-rent/essex-and-kent/" : "/new-homes-to-rent/essex-and-kent/"))) +
      (buildingValue ? buildingValue + "/" : '') +
      (bedroomValue && bedroomValue != "0" ? bedroomValue + "-and-more-bedrooms/" : '') +
      (priceUrl ? priceUrl + "/" : '')

      :

      (areaValue ? (props.type === "sales" ? (props.tag === "map" ? "/properties-map/for-sale/" + areaValue + "/" : "/properties-for-sale/" + areaValue + "/") : (props.tag === "map" ? "/properties-map/to-rent/" + areaValue + "/" : "/properties-to-rent/" + areaValue + "/")) : (props.type === "sales" ? (props.tag === "map" ? "/properties-map/for-sale/essex-and-kent/" : "/properties-for-sale/essex-and-kent/") : (props.tag === "map" ? "/properties-map/to-rent/essex-and-kent/" : "/properties-to-rent/essex-and-kent/"))) +
      (buildingValue ? buildingValue + "/" : '') +
      (bedroomValue && bedroomValue != "0" ? bedroomValue + "-and-more-bedrooms/" : '') +
      (priceUrl ? priceUrl + "/" : '')
    );

    navigate(searchFilterResults)
    // console.log("$$$$$$$", searchFilterResults, props.type, searchTypeValue)
  }
  // Submit search

  // Sales & Rent dropdown
  const onChangeSellRent = (e) => {
    navigate(`/${e[0].value}`)
  }
  // Sales & Rent dropdown


  return ( 
        <React.Fragment>
            <div className="filter">
           <button className="filter-show"> Filter your results
            <i className={show ? "icon-minue-white icon-plus-white " : "icon-plus-white "}   onClick={showMenu}></i></button>
           <div className={show ? "filter-field show-fliter " : "filter-field "}>
          <Container>
            <Row>
              <Col className="filter-fixed ">
                <Form className="form-data">
                  <div className="search-box">
                    <SearchInputBox areaVal={areaVal}/>
                    {/* <Form.Control
                      type="search"
                      placeholder={"Find a property by area, street or postcode"}
                      handleChange={(val)=> setAreaVal(val)}
                      defaultValue={areaVal}
                    /> */}
                    <i className="icon-locationgray"></i>
                  </div>
                
                  <div className="box-wrapper d-lg-flex align-items-center">
                    <div className="select-boxes buy-select">
                      {
                        props.department === "new_developments" ?
                        <Select placeholder="Buy" searchable={false}
                          options={[
                            { value: props.tag === "map" ? "new-homes-map/for-sale/essex-and-kent/" : "new-homes-for-sale/essex-and-kent/", label: "Buy" },
                            { value: props.tag === "map" ? "new-homes-map/to-rent/essex-and-kent/" : "new-homes-to-rent/essex-and-kent/", label: "Rent" },
                          ]}
                          onChange={onChangeSellRent}
                          
                        />
                        :
                        props.type === "sales" ?
                        <Select placeholder="Buy" searchable={false}
                          options={[
                            { value: props.tag === "map" ? "properties-map/for-sale/essex-and-kent/" : "properties-for-sale/essex-and-kent/", label: "Buy" },
                            { value: props.tag === "map" ? "properties-map/to-rent/essex-and-kent/" : "properties-to-rent/essex-and-kent/", label: "Rent" },
                          ]}
                          onChange={onChangeSellRent}
                          
                        />
                        :
                        <Select placeholder="Rent" searchable={false}
                          options={[
                            { value: props.tag === "map" ? "properties-map/for-sale/essex-and-kent/" : "properties-for-sale/essex-and-kent/", label: "Buy" },
                            { value: props.tag === "map" ? "properties-map/to-rent/essex-and-kent/" : "properties-to-rent/essex-and-kent/", label: "Rent" },
                          ]}
                          onChange={onChangeSellRent}
                        />
                      }
                    </div>
                    <div className="select-boxes min-price-select">
                      <Select 
                        placeholder={minpriceVal ? (props.type === "sales" ? "£"+minpriceVal : "£"+minpriceVal+ "pcm") : "Min Price"}
                        searchable={false}
                        options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.type === "sales" ? minPrice : minPriceLettings)}
                        defaultValue={minPriceList.find(obj => obj.value === minpriceVal)}
                        onChange={e => { onChangeMinPrice(e); setMinPriceVal(e[0].value) }}
                      />
                    </div>
                    
                    <div className="select-boxes max-price-select">
                      <Select 
                        placeholder={maxpriceVal ? (props.type === "sales" ? "£"+maxpriceVal : "£"+maxpriceVal+ "pcm") : "Max Price"}
                        searchable={false}
                        options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.type === "sales" ? maxPrice : maxPriceLettings)}
                        defaultValue={maxPriceList.find(obj => obj.value === maxpriceVal)}
                        onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e[0].value) }}
                      />
                    </div>

                    <div className="select-boxes bedroom-select">
                      <Select 
                        placeholder={bedVal ? bedVal+" +" : "Bedrooms"}
                        searchable={false}
                        options={Bedrooms}
                        defaultValue={Bedrooms.find(obj => obj.value === bedVal)}
                        onChange={e => setBedVal(e[0].value)}
                      />
                    </div>
                    <div className="select-boxes type-select">
                      <Select  searchable={false}
                          placeholder={propertyval ? propertyval : "All Types"}
                          options={AllTypes}
                          // defaultValue={} 
                          values={[AllTypes.find(obj => obj.value === propertyval)]}
                          onChange={e => setPropertyVal(e[0].value)}
                      />
                    </div>
                    <div className="select-boxes clear-select">
                      {isMobileOnly ?
                      <button type="button" className="btn m-0" onClick={() => { submitSearch();setShow(false); }}>Submit</button>
                      :
                      <button type="button" className="btn m-0" onClick={() => { submitSearch() }}>Submit</button>
                      }
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
        </div>
        </React.Fragment>
    )
}
export default FilterBlock